import 'vendor-auto-grow-input'
import { initCKEditor } from '../shared'
import PublicationStatus from '../components/publication-status'

class BlogPostView {
  constructor($el) {
    if (!$el.length) return
    this.$root = $el
    this.$form = this.$root.find('.content-editor')
    this.$root.find('.content-editor__title').autoGrowInput({ minWidth: 130, maxWidth: 600 })
    this.editor = null

    this.initEditor()
    this.initPublicationControl()
    this.initParentPageSelect()

    this.initSelect2()

    $(document).keydown(this.handleKeyDown.bind(this))
  }

  initSelect2() {
    // Set up original article
    const $canonicalResources = this.$root.find('.js-canonical-resources')
    $canonicalResources.select2({
      templateResult: state => {
        const takenIds = $canonicalResources.data('takenIds')
        const isResumeTaken = takenIds.indexOf(parseInt(state.id)) !== -1

        if (!state.id) {
          return state.text
        }
        const template = `
          <span class="${isResumeTaken ? 'assoc-resume-item--taken' : ''}">
            ${state.text}
          </span>
        `
        return $(template)
      },
    })
  }

  initEditor() {
    const el = this.$root.find('.content-editor__editor')
    const publications = (el.data('publications') || []).map(this.camelizeKeys)

    initCKEditor(el.get(0), {
      internalLink: { publications },
    })
      .then(newEditor => {
        this.editor = newEditor
        this.editor.editing.view.focus()
      })
      .catch(error => {
        console.error(error)
      })
  }

  initPublicationControl() {
    const $publication = this.$root.find('.js-publication')

    const publicationStatus = new PublicationStatus($publication)

    $publication.on('change', () => {
      publicationStatus.updateStatus()
    })
  }

  initParentPageSelect() {
    const $parentPageSelect = this.$root.find('.js-parent-page-select')
    const $categoryId = this.$root.find('.js-category-id')
    const $parentPostId = this.$root.find('.js-parent-post-id')

    $parentPageSelect.on('change', e => {
      $parentPostId.val('')
      $categoryId.val('')

      if (!e.target.value) return

      const [type, id] = e.target.value.split('_')
      if (type === 'category') $categoryId.val(id)
      if (type === 'guide') $parentPostId.val(id)
    })
  }

  camelizeKeys(obj) {
    return Object.keys(obj).reduce((camelCasedObj, field) => {
      return {
        ...camelCasedObj,
        [_.camelCase(field)]: obj[field],
      }
    }, {})
  }

  handleKeyDown(event) {
    if (!this.editor) return

    if ((event.ctrlKey || event.metaKey) && event.which === 83) {
      event.preventDefault()
      this.editor.updateSourceElement()
      this.$form.submit()
      return false
    }

    if ((event.ctrlKey || event.metaKey) && event.which === 80) {
      event.preventDefault()
      document.getElementById('preview-link').click()
      return false
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  return new BlogPostView($('.blog-post-view'))
})
